import VprSubtheme from './VprSubtheme'

export default class VprTheme {
  constructor (data, vprProgress = null) {
    if (!data && !data.id) throw new Error('Wrong VprTheme data')

    this.id = data.id
    this.title = data.theme_name ?? ''

    this.subthemes = data.subthemes
      ? data.subthemes
        .sort((prev, next) => prev.id - next.id)
        .map(vprSubtheme => new VprSubtheme(vprSubtheme, this, vprProgress))
      : []
  }

  get countTasks () {
    return this.subthemes.reduce((acc, subtheme) => acc + subtheme.countTasks, 0)
  }

  findSubthemeById (id) {
    return this.subthemes.find(subtheme => subtheme.id === id) ?? null
  }

  findTaskById (id) {
    let result = null
    this.subthemes.some(subtheme => {
      result = subtheme.findTaskById(id)
      return Boolean(result)
    })
    return result
  }
}
